import React, { useState } from 'react'
import axios from 'axios'
import { Button, Box, TextField, Alert } from '@mui/material'

import { WrappedCard as RegistrationCard } from '../registration/RegistrationCard'

const Admin = () => {
  const [emailAddress, setEmailAddress] = useState('')
  const [success, setSuccess] = useState(false)

  const handleRegister = () => {
    return axios
      .post('/api/registration/admin', {
        emailAddress,
      })
      .then(() => {
        setSuccess(true)
        // navigate('/superadmin')
      })
  }
  return (
    <RegistrationCard title={'Welcome back!'} sx={{ width: '500px' }}>
      {success && <Alert>Success. Check your email</Alert>}
      {!success && (
        <form>
          <TextField
            fullWidth
            margin={'dense'}
            value={emailAddress}
            label={'Email Address'}
            onChange={(e) => {
              setEmailAddress(e.target.value)
            }}
          />

          <Box
            sx={{
              margin: '8px 0',
              display: 'flex',
              justifyContent: 'space-between',
            }}
          >
            <Button
              type='submit'
              variant={'contained'}
              onClick={(e) => {
                e.preventDefault()
                handleRegister()
              }}
              disabled={!emailAddress}
            >
              Register
            </Button>
          </Box>
        </form>
      )}
    </RegistrationCard>
  )
}

export default Admin
